import React       from 'react';
import ReactDOM    from 'react-dom';
import routes      from './routes';
import App         from 'components/App/App';
import * as Sentry from '@sentry/react';
import ConfigProxy from 'tools/ConfigProxy';

// moved in App to work with vite
// import './documentAddEventListenerKeyPress';

// Sentry.init({
// 	dsn: "https://7b8367f9d87b4a058fb13eab97350da7@o240489.ingest.us.sentry.io/1839421",
// 	// Setting this option to true will send default PII data to Sentry.
// 	// For example, automatic IP address collection on events
// 	sendDefaultPii: true
// });

if (ConfigProxy.get('SENTRY_DSN')) {
	Sentry.init({
		beforeSend(event, hint) {
			console.error(`SENTRY SEND\n`, hint?.originalException);

			return event;
		},

		dsn: ConfigProxy.get('SENTRY_DSN'),
		environment: ConfigProxy.get('APP_ENV'),
		ignoreErrors: [
			'ResizeObserver loop limit exceeded',
			'ResizeObserver loop completed with undelivered notifications.',
			/-> Network Error/,
			/-> Request failed with status code/,
		],
		integrations: [
			// new Sentry.Replay()
		],
		// If the entire session is not sampled, use the below sample rate to sample sessions when an error occurs.
		replaysOnErrorSampleRate: 1.0,
		// This sets the sample rate to be 10%. You may want this to be 100% while in development and
		// sample at a lower rate in production
		replaysSessionSampleRate: 0.1,
		tracesSampleRate: 0.2,
	});

	Sentry.setContext('app-context', {
		app: 'lsd',
	});
}

const render = Component => {
	ReactDOM.hydrate(
		<Component
			routes={routes}
			history={history}
		/>,
		document.getElementById('main')
	);
};

render(App);

// if (module.hot) {
// 	module.hot.accept('./components/App/App', () => {
// 		const nextApp = require('./components/App/App').default;
// 		render(nextApp) ;
// 	});
// }
//
// if (!!ConfigProxy.get('SENTRY_DSN')) {
// 	Raven.config(ConfigProxy.get('SENTRY_DSN'), {
// 		release: version,
// 		environment: ConfigProxy.get('APP_ENV'),
// 	}).install();
// }
//
// Raven.setUserContext({});
